export const state = {
    marketTestsList: []
};